module.exports = __webpack_public_path__ + "media/images/ui__textArrowLeft--dark-ba0aaf6ef49151eb1ba50ca0289724b1.png";